<template>
  <div class="home-skeleton">
    <div class="item" v-for="i in 10" :key="i" :style="{ backgroundColor: bg }">
      <shSkeleton bg="#e4e4e4" width="150px" height="30px" animated />
      <shSkeleton bg="#e4e4e4" width="30px" height="30px" animated />
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSkeleton",
  props: {
    bg: {
      type: String,
      default: "#313131",
    },
  },
};
</script>

<style scoped lang="less">
.home-skeleton {
  width: 250px;
  height: 500px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .item {
    display: flex;
    align-items: center;
    margin-left: 30px;
    padding-right: 5px;
    width: 250px;
    .sh-skeleton ~ .sh-skeleton {
      display: block;
      margin: 0 0 0 30px;
    }
  }
}
</style>
